import { NAME } from "./constants";

export const SET_HOME_LOADING = `${NAME}/SET_HOME_LOADING`;

export const SET_HOME_LOGGED_IN = `${NAME}/SET_HOME_LOGGED_IN`;

export const SET_IS_USER_REAL = `${NAME}/SET_IS_USER_REAL`;

export const SET_IS_USER_ADMIN = `${NAME}/SET_IS_USER_ADMIN`;